import React, { useState } from "react";
import "./DeathDashboard/deathDashboard.css";
import * as Style from "./styledComponents/AudioVideo";
import { Modal } from "antd";

export const AdsContainer = (props) => {
  const [tooltipModal, setTooltipModal] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [clickedItem, setClickedItem] = useState(null);
  const handleOnChange = () => {
    setIsChecked(!isChecked);
  };
  const showTooltipModal = () => {
    setTooltipModal(true);
  };

  const handleTooltipCancel = () => {
    setTooltipModal(false);
    setIsChecked(false);
    setClickedItem(null);
  };
  const handleTooltipOk = () => {
    setTooltipModal(false);
    if (isChecked) {
      window.open(clickedItem.href, "blank");
    }
    setIsChecked(false);
    setClickedItem(null);
  };
  return (
    <div>
      <div
        className={`${props.name === "Checklist" ? "carousel1" : "carousel"} `}
      >
        {props &&
          props.images &&
          props.images.map((item, index) => (
            <div
              onClick={() => {
                showTooltipModal();
                setClickedItem(item);
              }}
              key={index}
              style={{ marginRight: `${props.name === "Checklist" ? "7%" : "15%"} `, cursor: "pointer" }}
            >
              <div style={{ textAlign: "center" }}>
                {item.name && item.name}
              </div>
              <img
                src={item.fileName}
                height={100}
                width={`${props.name === "Checklist" ? "100%" : "300"} `}
                alt={item.href}
              />
            </div>
          ))}
      </div>
      <Modal
        centered
        visible={tooltipModal}
        footer={null}
        onCancel={handleTooltipCancel}
      >
        <Style.ModalTitle> Third-Party Disclaimer</Style.ModalTitle>
        <div style={{}}>
          <div className="">
            <Style.ModalDetails>
              <p>
                <strong style={{ fontSize: "15px" }}>
                  Third-Party Disclaimer;{" "}
                </strong>
                This website may contain links to third-party websites. Asset
                Planet is not responsible for the content, accuracy, or privacy
                practices of any third-party website. When you click on a link
                to a third-party website, you are leaving our website and
                entering the third-party website at your own risk. We encourage
                you to review the privacy policy of any third-party website
                before you provide them with any personal information.
                <br />
                <br />
                <strong style={{ fontSize: "15px" }}>
                  Disclaimer of Liability;{" "}
                </strong>{" "}
                We make no representations or warranties of any kind, express or
                implied, as to the operation of this website or the information,
                content, materials, or products included on this website. To the
                fullest extent permitted by law, we disclaim all liability for
                any damages of any kind, including direct, indirect, incidental,
                punitive, and consequential damages, arising out of or in
                connection with your access to or use of this website.
                <br />
                <br />
                <strong style={{ fontSize: "15px" }}>
                  Compensation; if Asset Planet receives any 3rdd party discount
                  we pass it along to our members. If Asset Planet receives a
                  commission from 3rd party due to our members purchasing some
                  item of their choosing, then our members will receive rewards
                  points. The points shall be calculated at a rate of no less
                  than 50% cash value at the time of initial transaction
                  completion. Points can be redeemed against annual renewals,
                  special promotions, in-app upgrades, and other items
                  available, and subject to change.{" "}
                </strong>
                <br />
                <br />
                <label class="container1">
                  <input
                    type="checkbox"
                    id="check"
                    name="check"
                    value="yes"
                    checked={isChecked}
                    onChange={handleOnChange}
                  />
                  <span class="checkmark"></span>
                  You agree to hold us harmless from and against any and all
                  claims, losses, damages, and expenses (including reasonable
                  attorneys' fees) arising out of or in connection with your use
                  of this website.
                </label>
              </p>
            </Style.ModalDetails>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Style.CancelButton
              disabled={!isChecked}
              onClick={() => {
                handleTooltipOk();
              }}
            >
              Confirm
            </Style.CancelButton>
          </div>
        </div>
      </Modal>
    </div>
  );
};
